'use client';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DownArrowIcon, UpArrowIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { CalendarHolidaysViewModel } from '@api/v3';

import DateRangePicker, {
  DayPickerRangeControllerProps,
} from './DateRangePicker';
import { ResponsiveNavDownButton } from '../DatePickerStyle';

const ResponsiveDateRangePicker = (
  props: DayPickerRangeControllerProps,
  isHoliday?: boolean,
  initialData?: CalendarHolidaysViewModel,
  isPadding?: boolean
) => {
  return (
    <DateRangePicker
      initialData={initialData}
      isHoliday={isHoliday}
      isPadding={isPadding}
      orientation='verticalScrollable'
      numberOfMonths={12}
      renderNavPrevButton={(props) => (
        <ResponsiveNavDownButton variant='Text' {...props}>
          <CustomIcon
            icon={UpArrowIcon}
            fontSize={20}
            paletteColor='darkGray'
          />
        </ResponsiveNavDownButton>
      )}
      renderNavNextButton={(props) => (
        <ResponsiveNavDownButton variant='Text' {...props}>
          <CustomIcon
            icon={DownArrowIcon}
            fontSize={20}
            paletteColor='darkGray'
          />
        </ResponsiveNavDownButton>
      )}
      daySize={38}
      {...props}
    />
  );
};

export default ResponsiveDateRangePicker;
